import React, { useEffect, useState } from "react";

import { Button } from "shared/ui/Button";
import { LabeledField } from "shared/ui/LabeledField";
import { Modal } from "shared/ui/Modal";
import { TextInput } from "shared/ui/TextInput";

interface RenameDialogProps {
    open: boolean;
    name: string;
    saving: boolean;
    onClose: () => void;
    onSubmit: (name: string) => void;
}

export const RenameDialog = ({ open, name, saving, onClose, onSubmit }: RenameDialogProps) => {
    const [value, setValue] = useState(name);

    useEffect(() => {
        if (open) setValue(name);
    }, [open, name]);

    const trimmed = value.trim();

    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Название заведения"
            maxWidth="xs"
            actions={
                <>
                    <Button variant="text" color="neutral" onClick={onClose} disabled={saving}>
                        Отмена
                    </Button>
                    <Button onClick={() => onSubmit(trimmed)} disabled={saving || trimmed === ""}>
                        Сохранить
                    </Button>
                </>
            }
        >
            <LabeledField label="Название" htmlFor="branchName">
                <TextInput id="branchName" value={value} onChange={setValue} disabled={saving} />
            </LabeledField>
        </Modal>
    );
};
